export default "__VITE_ASSET__BW$XKU5l__"